import script from "./NavigationButton.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationButton.vue?vue&type=script&setup=true&lang=js"

import "./NavigationButton.vue?vue&type=style&index=0&id=ee3e03c2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee3e03c2"]])

export default __exports__